import { gql } from '@apollo/client';

export const BANK_INSTITUTION = gql`
  fragment BankInstitution on BankInstitution {
    plaidInstitutionId
    name
    institutionUrl
    primaryColor
    logoUrl
    bankInstitutionKey
  }
`;

const BANK_DATA_PROVIDER_INSTITUTION_ACCOUNT = gql`
  fragment BankDataProviderInstitutionAccountFields on BankDataProviderInstitutionAccount {
    dataProviderAccountId
    bankInstitutionId
    name
    mask
    type
    current
    available
    currency
    retrievedAt
  }
`;

export const BANK_DATA_PROVIDER_INSTITUTION_FIELDS = gql`
  ${BANK_DATA_PROVIDER_INSTITUTION_ACCOUNT}
  fragment BankDataProviderInstitutionFields on BankDataProviderInstitution {
    bankInstitutionId
    name
    bankInstitutionKey
    dataProvider
    dataProviderInstitutionId
    itemId
    institutionUrl
    primaryColor
    logoUrl
    externalItemId
    needsUpdate
    bankAccounts {
      ...BankDataProviderInstitutionAccountFields
    }
  }
`;
